import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./CategoriesModal.css";

function CategoriesModal({ isOpen, onClose, selectedCategories, onToggleCategory }) {
  const { t } = useTranslation();
  const [allCategories, setAllCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

  // Buscar todas as categorias da API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${BACKEND_URL}/api/bots/categories`);
        const data = await response.json();
        setAllCategories(data);
      } catch (err) {
        console.error("Erro ao buscar categorias:", err);
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      fetchCategories();
    }
  }, [isOpen, BACKEND_URL]);

  // Bloquear scroll da página quando modal estiver aberto
  useEffect(() => {
    if (isOpen) {
      // Salva a posição atual do scroll
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
    } else {
      // Restaura o scroll quando fechar
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }

    // Cleanup ao desmontar
    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const selectedCount = selectedCategories.filter((c) => c !== "Todos").length;

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content categories-modal">
        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">
            <span>📂</span> {t("categoriesModal.title")}
          </h2>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <p className="modal-subtitle">{t("categoriesModal.subtitle")}</p>

          <div className="categories-grid">
            {loading ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "2rem",
                  color: "var(--text-secondary)",
                }}
              >
                {t("categoriesModal.loading")}
              </div>
            ) : (
              allCategories.map((category) => (
                <button
                  key={category.name}
                  className={`category-item ${selectedCategories.includes(category.name) ? "active" : ""}`}
                  onClick={() => onToggleCategory(category.name)}
                >
                  <div className="category-item-icon">{category.icon || "📌"}</div>
                  <div className="category-item-info">
                    <div className="category-item-name">{category.name}</div>
                    <div className="category-item-desc">{category.description || t("categoriesModal.defaultDesc")}</div>
                  </div>
                  {selectedCategories.includes(category.name) && <div className="category-item-check">✓</div>}
                </button>
              ))
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <div className="modal-footer-info">
            {selectedCount === 1
              ? t("categoriesModal.selectedCount", { count: selectedCount })
              : t("categoriesModal.selectedCountPlural", {
                  count: selectedCount,
                })}
          </div>
          <div className="modal-footer-actions">
            <button className="btn btn-outline" onClick={() => onToggleCategory("Todos")}>
              {t("categoriesModal.clearAll")}
            </button>
            <button className="btn btn-primary" onClick={onClose}>
              {t("categoriesModal.apply")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CategoriesModal;
